import { BCR, Traditional } from "best-common-react";
import React, { useEffect, useState } from "react";
import { getUIConfig, saveUIConfig } from "../api/ScoreboardApi";
import SliderConfig from "../components/config/SliderConfig";
import ThinConfig from "../components/config/ThinConfig";
import { useSearchParams } from "../context/SearchParamsContext";
import {
  DefaultUIConfig,
  UITheme,
  VenueUIConfig,
  VenueUIConfigOptions,
  VenueUIConfigOptionsKeys,
} from "../types/Config";

const ConfigPage: React.FC = () => {
  const {
    params: { venueGuid, pitchersView },
  } = useSearchParams();
  const [config, setConfig] = useState<VenueUIConfig | undefined>();

  const getConfig = async (venueGuid: string) => {
    try {
      const result: VenueUIConfig = await getUIConfig(venueGuid);
      if (!!result.strikeZoneConfig) {
        setConfig({
          ...result,
          strikeZoneConfig: JSON.parse(result.strikeZoneConfig as string),
          thinConfig: JSON.parse(result.thinConfig as string),
        });
      } else {
        setConfig({ ...result, strikeZoneConfig: DefaultUIConfig, thinConfig: DefaultUIConfig });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const saveConfig = async (venueConfig: VenueUIConfig) => {
    try {
      await saveUIConfig(venueGuid, venueConfig);
    } catch (e) {
      console.error(e);
    }
  };

  const onChangeSlider = (key: VenueUIConfigOptionsKeys, value: UITheme | string | number | boolean) => {
    const newConfig: VenueUIConfig = {
      ...config,
      strikeZoneConfig: { ...(config.strikeZoneConfig as VenueUIConfigOptions), [key]: value },
    };
    setConfig(newConfig);
    void saveConfig(newConfig);
  };

  const onChangeThin = (key: VenueUIConfigOptionsKeys, value: UITheme | string | number | boolean) => {
    const newConfig: VenueUIConfig = {
      ...config,
      thinConfig: { ...(config.thinConfig as VenueUIConfigOptions), [key]: value },
    };
    setConfig(newConfig);
    void saveConfig(newConfig);
  };

  useEffect(() => {
    if (!!venueGuid) {
      void getConfig(venueGuid);
    }
  }, [venueGuid]);

  return (
    <BCR theme={Traditional}>
      <div className="container">
        {!!config && (
          <div className="mt-2">
            <SliderConfig config={config} onChange={onChangeSlider} pitchersView={pitchersView} />
            <div className="mt-4">
              <ThinConfig config={config} onChange={onChangeThin} pitchersView={pitchersView} />
            </div>
          </div>
        )}
      </div>
    </BCR>
  );
};

export default ConfigPage;
